import React, { useState, useMemo, useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import UserContext from '../../services/userService'
import CsvDialog from '../../Components/Dialogs'
import UsersSection from './UsersSection'

const rollupStatusFilters = {
  ALL_ACTIVE: ['ACTIVE', 'INVITED'],
  ALL: ['ACTIVE', 'INACTIVE', 'INVITED'],
}

const UserListContainer = () => {
  const service = useContext(UserContext)
  const location = useLocation()
  const newUser = location.state?.newUser
  const [users, setUsers] = useState(newUser ? [newUser] : [])

  const [isLoading, setIsLoading] = useState(true)

  const[filters, setFilters] = useState({
    searchText: '',
    status: 'ALL_ACTIVE',
    role: 'ALL',
  })

  const [errorMessage, setErrorMessage] = useState(null)

  const filteredUsers = useMemo(() => {
    return users
      .filter(({ emailAddress, fullName, role, status }) => {
        return (rollupStatusFilters[filters.status]
          ? rollupStatusFilters[filters.status].includes(status)
          : filters.status === status)
          && (filters.role === 'ALL' || filters.role === role)
          && (
            filters.searchText === '' ||
            emailAddress.toLowerCase().includes(filters.searchText.toLowerCase()) || 
            fullName.toLowerCase().includes(filters.searchText.toLowerCase()))
      })
      .sort(({ fullName: a, emailAddress: aEmail }, { fullName: b, emailAddress: bEmail }) => {
        if (a === b) {
          return aEmail.localeCompare(bEmail)
        }
        if (a === 'undefined undefined') {
          return 1
        }
        if (b === 'undefined undefined') {
          return -1
        }
        return a.localeCompare(b)
      })
  }, [users, filters])

  useEffect(() => {
    let isActive = true

    const getUsers = async () => {
      try {
        const fetchedUsers = await service.listAllUsers()
        if (!isActive) {
          return
        }
        // The invite mutation returns the full user row synchronously, so we already
        // know it exists even if this fetch raced the backend's async persistence.
        const merged = newUser && !fetchedUsers.some(({ userId }) => userId === newUser.userId)
          ? [...fetchedUsers, newUser]
          : fetchedUsers
        setUsers(merged)
        setIsLoading(false)
      } catch (error) {
        console.error(error)
        if (isActive) {
          setErrorMessage('Something went wrong fetching records.')
        }
      }
    }

    getUsers()

    return () => {
      isActive = false
    }
  }, [service, newUser])

  const handleCancelInvite = (userId) => {
    // The backend cancel is event-driven and may take time to reflect in a
    // subsequent fetch, so drop the row from local state immediately rather
    // than waiting on a refetch.
    setUsers((current) => current.filter((user) => user.userId !== userId))
  }

  const handleCancelInviteError = () => {
    setErrorMessage('Something went wrong canceling the invite. Please try again.')
  }

  return (
    <>
      {errorMessage && (
        <CsvDialog
          open={Boolean(errorMessage)}
          handleClose={() => setErrorMessage(null)}
          type={'error'}
          message={errorMessage}
        />
      )}
      <UsersSection
        users={filteredUsers}
        filters={filters}
        setFilters={setFilters}
        isLoading={isLoading}
        onCancelInvite={handleCancelInvite}
        onCancelInviteError={handleCancelInviteError}
      />
    </>

  )
}



export default UserListContainer
